// extracted by mini-css-extract-plugin
export default {"agbContainer":"AGB_agbContainer__jkM41","agb-title":"AGB_agb-title__q+n9M"};